var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"title has-text-centered"},[_c('go-to-dashboard-button'),_vm._v("\n\n  "+_vm._s(_vm.$t("productCreation.title"))+"    \n\n  "),_c('hr')],1)}
var staticRenderFns = []

export { render, staticRenderFns }